import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';
import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import {
  SEARCH_CUSTOMER_PAGE_PATH,
  SEARCH_ORDER_PAGE_PATH,
  PAGE_TEXTS_KEYS,
} from '../../../../../../../constants/constant';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../../../../ui/card';
import { Table } from '../../../../ui/customTable/Table';
import { ORDER_SEARCH_TYPES } from '../../../constants';

const Index = ({ columnsData, allRowsData, pagePath }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  const selectedSearchType = useSearchParams()?.get('selectedSearchType');
  const orderId = useSearchParams()?.get('orderId');

  const noRecordsFoundMessage = useCallback(() => {
    if (allRowsData?.length) return null;

    const baseClass = 'text-18 font-bold';

    const msg = orderId
      ? `${Texts?.noOrderRecordsFoundWithOrderId} ${orderId}`
      : Texts?.noOrderRecordsFoundWithRecipient;

    switch (pagePath) {
      case SEARCH_CUSTOMER_PAGE_PATH:
        return <span className={baseClass}>{Texts?.noCustomerRecordsFound}</span>;

      case SEARCH_ORDER_PAGE_PATH:
        switch (selectedSearchType) {
          case ORDER_SEARCH_TYPES?.orderQueues:
            return <span className={baseClass}>{Texts?.noOrderRecordsFoundWithQueues}</span>;

          case ORDER_SEARCH_TYPES?.recipient:
            return <span className={baseClass}>{Texts?.noOrderRecordsFoundWithRecipient}</span>;

          case ORDER_SEARCH_TYPES?.orderId:
            return <span className={baseClass}>{msg}</span>;

          default:
            return null;
        }

      default:
        return null;
    }
  }, [pagePath, allRowsData, selectedSearchType, orderId]);

  const recordsFoundMessage = useCallback(() => {
    if (allRowsData?.length > 0) {
      return (
        <>
          <span className="text-18 font-bold">
            {pagePath === SEARCH_CUSTOMER_PAGE_PATH
              ? Texts?.tableCustomerSearchResultsHeading
              : Texts?.tableOrderSearchResultsHeading}
          </span>
          <span className="mt-5 block text-14 font-normal">
            {`${Texts?.recordSearchDisplay} ${allRowsData.length} of ${allRowsData.length} ${
              pagePath === SEARCH_CUSTOMER_PAGE_PATH ? Texts?.customerRecordSearchMatch : Texts?.orderRecordSearchMatch
            }`}
          </span>
        </>
      );
    }
    return null;
  }, [pagePath, allRowsData]);

  return (
    <Card className="mt-5">
      <CardHeader>
        <CardTitle>
          {noRecordsFoundMessage()}
          {recordsFoundMessage() && <CardDescription>{recordsFoundMessage()}</CardDescription>}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {allRowsData?.length > 0 && <Table columns={columnsData} data={allRowsData} alignTextTop />}
      </CardContent>
    </Card>
  );
};

export default Index;
